import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ArcGlobalLoading } from "@src/core/widgets";
import { FlightProvider } from "@src/features/order/provider";
import { routesConfig } from "@src/core/routes";

const ChecklistFeature = React.lazy(() => import("@src/features/checklist"));
const DroneFeature = React.lazy(() => import("@src/features/drone"));
const OrderFeature = React.lazy(() => import("@src/features/order"));
const ProfileFeature = React.lazy(() => import("@src/features/profile"));
const HistoryFeature = React.lazy(() => import("@src/features/history"));
const ZonesFeature = React.lazy(() => import("@src/features/zones/feature"));
const FleetFeature = React.lazy(() => import("@src/features/fleet"));
const HubsFeature = React.lazy(() => import("@src/features/hubs"));

const OperatorRoutes: React.FC = () => {
  return (
    <FlightProvider>
      <React.Suspense fallback={<ArcGlobalLoading />}>
        <Routes>
          <Route path="/history" element={<HistoryFeature />} />
          <Route path="/history/*" element={<HistoryFeature />} />
          <Route path="/orders" element={<OrderFeature />} />
          <Route path="/orders/*" element={<OrderFeature />} />
          <Route path="/zones" element={<ZonesFeature />} />
          <Route path="/zones/*" element={<ZonesFeature />} />
          <Route path="/drones" element={<DroneFeature />} />
          <Route path="/drones/*" element={<DroneFeature />} />
          <Route path="/fleet" element={<FleetFeature />} />
          <Route path="/fleet/*" element={<FleetFeature />} />
          <Route path="/hubs" element={<HubsFeature />} />
          <Route path="/hubs/*" element={<HubsFeature />} />
          <Route path="/profile" element={<ProfileFeature />} />
          <Route path="/profile/*" element={<ProfileFeature />} />
          <Route path="/checklist" element={<ChecklistFeature />} />
          <Route path="/checklist/*" element={<ChecklistFeature />} />
          <Route path="/" element={<Navigate to={routesConfig.orders} replace />} />
          <Route path="*" element={<Navigate to={routesConfig.orders} />} />
        </Routes>
      </React.Suspense>
    </FlightProvider>
  );
};

export default OperatorRoutes;
